import styled from "styled-components";
import {
  space,
  flex,
  layout,
  boxShadow,
  grid,
  SpaceProps,
  LayoutProps,
  BoxShadowProps,
  FlexboxProps,
  GridProps,
} from "styled-system";

export const Panel = styled.div<
  SpaceProps & FlexboxProps & LayoutProps & BoxShadowProps & GridProps
>`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.colors.background};
  border-radius: 6px;
  ${flex};
  ${space};
  ${layout};
  ${boxShadow};
  ${grid};
`;

Panel.defaultProps = {
  p: 2,
  boxShadow: 1,
};

export const PanelHeader = styled.div<SpaceProps>`
  border-bottom: ${(props) => props.theme.borders[1]};
  ${space};
`;

PanelHeader.defaultProps = {
  p: 2,
};

export const PanelBody = styled.div`
  position: relative;
  flex: 1;
  min-height: 0;
`;
